import moment from 'moment-timezone';

import {DELIVERY_RULES, DeliveryMethod, DeliveryMethods} from '~/shared/consts/restaurantConsts';
import {MutatedFutureOrderAvailableDatesAndTimes} from '~/shared/store/models/FutureOrderAvailableDatesAndTimes';
import {SettingsOption} from '~/shared/services/analytics/analyticsModels';
import {CommunicationMethodName} from '~/shared/services/bffService/api/interfaces/payloads';
import {SettingControllerName, ToggleName} from '~/shared/types/personalArea';

export const settingsOptionAnalyticsNameMap: Record<SettingControllerName, SettingsOption> = {
  [ToggleName.PROMOTIONS]: SettingsOption.Promotion,
  [ToggleName.RES_REVIEW]: SettingsOption.OrderFeedback,
  [CommunicationMethodName.PUSH]: SettingsOption.PushNotification,
  [CommunicationMethodName.EMAIL]: SettingsOption.Email,
  [CommunicationMethodName.SMS]: SettingsOption.Sms,
};

export const getOrderTypeString = (deliveryMethod: DeliveryMethod, deliveryRule: DELIVERY_RULES | null) => {
  if (deliveryMethod === DeliveryMethods.PICKUP) {
    return 'pickup';
  }

  if (deliveryRule === DELIVERY_RULES.POOL) {
    return 'pooled';
  }

  return deliveryRule?.toLowerCase() || '';
};

export const getFormatedDate = (date: MutatedFutureOrderAvailableDatesAndTimes, time: MutatedFutureOrderAvailableDatesAndTimes['times'][number]) => {
  const [hours, minutes] = time.timeKey.split(':');
  return moment(date.date, 'DD/MM/YYYY')
    .hours(Number(hours))
    .minutes(Number(minutes))
    .format()
    .replace('+03:00', '');
};
